<template>
	<div style="height: 100%;">

		<div style="height: 100%;background-color: white;">
			<el-card style="height: 100%;" shadow="always">
				<div style="font-size:1.3em ;color:#303133;margin-bottom: 10px;">角色权限管理</div>
				<el-form :inline="true" ref="form" :model="formInline" :rules="rules" class="demo-form-inline" style="">
					<el-form-item label="角色名称" prop="role_name">
						<el-input v-model="formInline.role_name" placeholder="请输入" clearable></el-input>
					</el-form-item>
					<el-form-item label="角色说明" prop="role_desc">
						<el-input v-model="formInline.role_desc" placeholder="请输入" clearable></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="addRole()">添加</el-button>
					</el-form-item>
				</el-form>
				<el-row :gutter="15">
					<el-col :span="12">
						<el-card>
							<div slot="header" class="clearfix"><span>角色列表</span></div>
							<el-tree :data="data" :props="defaultProps" ref="tree" node-key="id">

								<span class="custom-tree-node" slot-scope="{ node, data }">
									<span>{{ node.label }}</span>
									<span v-if="node.level==1">
										<el-button type="text" size="mini" @click="() => remove(node, data)">
											删除
										</el-button>
									</span>
								</span>
							</el-tree>

						</el-card>
					</el-col>
					<el-col :span="12">
						<el-card>
							<div slot="header" class="clearfix"><span>权限设置</span></div>
							<el-select @change="selectChange" v-model="role_id" placeholder="请选择" style="margin-bottom: 10px;">
								<el-option v-for="(item,idx) in data" :key="item.id" :label="item.label" :value="item.id">
								</el-option>
							</el-select>
							<span style="color: #E6A23C;font-size: 12px;">请先选择角色</span>
							<el-transfer :disabled="true"  ref="myTransfer" :titles="['所有权限','角色权限']" :props=" { key: 'id' , label: 'label' }" v-model="value" :data="allPermissions">
							</el-transfer>
							<div style="display: flex;justify-content: center;margin: 20px;">
								<el-button @click="clear()">重置</el-button>
								<el-button :disabled="role_id=='请选择'?true:false" type="primary" @click="savePermission()">保 存</el-button>
							</div>
						</el-card>
					</el-col>
				</el-row>
			</el-card>
		</div>
	</div>
</template>

<script>
	export default {
		inject:['reload'],
		data() {
			return {
				role_id: '请选择',
				value: [],
				rules: {
					role_name: [{
						required: true,
						message: '请输入角色名',
						trigger: 'blur'
					}],
					role_desc: [{
						required: true,
						message: '请输入说明',
						trigger: 'blur'
					}]
				},
				formInline: {},
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				allPermissions: [],
				data: []
			};
		},
		methods: {
			selectChange(e) {
				for (var i = 0; i < this.data.length; i++) {
					if (this.data[i].id == e) {
						this.value = this.data[i].permission;
					}
				}
				console.log(this.role_id);
				console.log(this.value);
			},
			addRole() {
				var that = this;
				this.$refs['form'].validate(function(val) {
					if (val) {
						that.$axios.post('api/fangyi/addRole', that.formInline).then(function(res) {
							if (res.data.success) {
								that.$message.success(res.data.desc);
								that.initRolesAndPermissionPage();
							} else {
								that.$message.error(res.data.desc);
							}
						});
					} else {
						that.$message.warning("请输入必填项");
					}
				})
			},
			handleNodeClick(data) {
				console.log(data);

			},
			initRolesAndPermissionPage() {
				var that = this;
				this.$axios.get('api/fangyi/initRolesAndPermissionPage').then(function(res) {
					if (res.data.success) {
						that.data = res.data.result.allRole;
						that.allPermissions = res.data.result.allPermissions;
					} else {
						that.$message.error(res.data.desc);
					}
				});
			},
			remove(node, data) {
				console.log(node);
				console.log(data);
				var that = this;
				this.$confirm('确定要删除吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.$axios.get('api/fangyi/deleteRole?id=' + data.id).then(function(res) {
						if (res.data.success) {
							that.$message.success(res.data.desc);
							that.initRolesAndPermissionPage();
						} else {
							that.$message.error(res.data.desc);
						}
					});
				})

			},
			savePermission() {
				console.log(this.value);
				var that = this;
				this.$axios.post('api/fangyi/saveRolePermission',{role_id:that.role_id,value:that.value}).then(function(res) {
					if (res.data.success) {
						that.$message.success(res.data.desc);
					} else {
						that.$message.error(res.data.desc);
					}
				});

			},
			clear(){
				this.reload()
			}
		},
		mounted() {
			this.initRolesAndPermissionPage();

		}
	};
</script>

<style>
	.custom-tree-node {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		padding-right: 8px;
	}
</style>



// WEBPACK FOOTER //
// src/components/juesequanxian.vue